import { FC, useContext, useMemo } from 'react';

import { Table } from '@smartshell/ui-kit';
import cn from 'classnames';

import { LocalizationContext } from 'localization';

import { CommonItem, GoodItem, IItemsReportProps } from './interfaces';
import s from './ItemsReport.module.scss';
import { useGetColumns } from './useGetColumns';
export const ItemsReport: FC<IItemsReportProps> = ({ data, loading }) => {
  const { t } = useContext(LocalizationContext);

  const { tariffsData, servicesData, goodsData } = useMemo(() => {
    const tariffs: CommonItem[] = [];
    const services: CommonItem[] = [];
    const goods: GoodItem[] = [];

    data?.topSoldOverviewItemsReport.summary?.forEach((item, index) => {
      const key = data.topSoldOverviewItemsReport.keys[index];
      const commonData: CommonItem = {
        title: item.title,
        sum: item.value,
        quantity: item.extraValue,
        img: '',
      };

      if (key === 'TARIFF') {
        tariffs.push(commonData);
      } else if (key === 'SERVICE') {
        services.push(commonData);
      } else if (key === 'GOOD') {
        goods.push({
          ...commonData,
          img: item.extraString || null,
        });
      }
    });

    return {
      tariffsData: tariffs.slice(0, 5),
      servicesData: services.slice(0, 5),
      goodsData: goods.slice(0, 5),
    };
  }, [data]);

  const { COLUMNS_TARIFFS, COLUMNS_SERVICES, COLUMNS_GOODS } = useGetColumns();
  return (
    <>
      <Table
        emptyDataPlaceholder={t('visitors.empty.data')}
        className={cn(s.table, s.table_img)}
        data={goodsData}
        columns={COLUMNS_GOODS}
        isLoading={loading}
      />
      <Table
        emptyDataPlaceholder={t('visitors.empty.data')}
        className={cn(s.table, s.table_img, s.table_non_img)}
        data={tariffsData}
        columns={COLUMNS_TARIFFS}
        isLoading={loading}
      />
      <Table
        emptyDataPlaceholder={t('visitors.empty.data')}
        className={cn(s.table, s.table_img, s.table_non_img)}
        data={servicesData}
        columns={COLUMNS_SERVICES}
        isLoading={loading}
      />
    </>
  );
};
